import { css } from '@emotion/css';

export const breadcrumbStyles = css`
  color: var(--text-primary);
`;
